import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Bluebird from 'bluebird';
import { Breadcrumbs, Typography } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import routes from '../routes';
import ReceiverAddForm from '../components/ReceiverAddForm';
import * as receiversActions from '../actions/receivers';
import OverlayLoader from '../components/OverlayLoader';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../pages/rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import snackbarHelper from '../helpers/snackbarHelper';

class ReceiverAddView extends Component {
  componentDidMount() {
    const { fetchReceiverTypes } = this.props;

    fetchReceiverTypes();
  }

  onCreateReceiver = values => {
    const { site, createReceiver, history, isMobileView } = this.props;

    return Bluebird
      .try(() => createReceiver({
        ...values,
        site_id: site.id,
      }))
      .then(() => history.push(isMobileView ? routes.index : routes.receivers))
      .then(() => snackbarHelper.success('Receiver added successfully!'))
      .catch(err => {
        throw err;
      });
  };

  render() {
    const { receiverTypes, isMobileView } = this.props;
    const isLoading = receiverTypes.inflight;
    const receiverTypesList = receiverTypes.allIds.map(id => receiverTypes.byId[id]);

    return (
      <>
        {isMobileView ? (
          <Breadcrumbs aria-label="Breadcrumbs">
            <StyledRescuerBreadcrumb
              component={Link}
              to={routes.index}
              label="Home"
              icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
            />
            <StyledRescuerTextBreadcrumb component="a" href="#" label="Add a Receiving Agency" />
          </Breadcrumbs>
        ) : (
          <Breadcrumbs aria-label="Breadcrumbs">
            <Link color="inherit" to={routes.receivers}>
              Receiving Agencies
            </Link>

            <Typography color="textPrimary">Add a Receiving Agency</Typography>
          </Breadcrumbs>
        )}

        <OverlayLoader isLoading={isLoading}>
          <ReceiverAddForm receiverTypeList={receiverTypesList} createReceiver={this.onCreateReceiver} />
        </OverlayLoader>
      </>
    );
  }
}

const mapStateToProps = ({ app: { site }, entities: { receivers } }, { isMobileView }) => ({
  site,
  receiverTypes: receivers.types,
  isMobileView,
});
const mapDispatchToProps = dispatch => {
  return {
    createReceiver: r => dispatch(receiversActions.createReceiver(r)),
    fetchReceiverTypes: () => dispatch(receiversActions.fetchReceiverTypes()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReceiverAddView)
);
